import React, { useEffect, useRef } from 'react'
import { withRouter } from 'react-router-dom'
import { withAuth } from '../AuthContext'
import { SubtitleOpen } from '../Utils/CustomClasses'
import MyFreebirdDashboardDivider from './MyFreebirdDashboardDivider'
import styled from 'styled-components'

const DashboardLeftContainer = styled.div`
  width: 40%;
  min-width: 260px;
  margin: 0 0 0 40px;
  border: 1px solid #f1eded;
  border-radius: 5px;

  @media screen and (max-width: 799px) {
    margin: 0 5% 0 5%;
    width: 90%;
  }
`

const DashboardLeftTitleBox = styled.div`
  padding: 16px 20px 16px 25px;
`

const DashboardLeftMainBox = styled.div`
  padding: 20px 25px 10px 25px;
`

const DashboardTitle = styled(SubtitleOpen)``

const MyFreebirdDashboardLeft = ({
  color,
  title,
  children,
  addPopup,
  messageTrigger,
}) => {
  const triggerRef = useRef(null)

  const DashboardLeftContainerContent = () => {
    return (
      <>
        <DashboardLeftTitleBox>
          <DashboardTitle
            color="#000"
            size="16px"
            sizemd="16px"
            sizesm="16px"
            lineheight="100%"
            weight="700"
            margin="0"
            dangerouslySetInnerHTML={{
              __html: `${title}:`,
            }}
          />
        </DashboardLeftTitleBox>
        <MyFreebirdDashboardDivider color={color} />
        <DashboardLeftMainBox>{children}</DashboardLeftMainBox>
      </>
    )
  }

  if (addPopup) {
    /*
    useEffect(() => {
      const observer = new IntersectionObserver((entries, observer) => {
        const entry = entries[0]
        const bcr = entry.boundingClientRect
        const isElementVisible = bcr.top < window.innerHeight
        messageTrigger(isElementVisible)
      })
      observer.observe(triggerRef.current)
    }, [])
    */

    return (
      <DashboardLeftContainer ref={triggerRef}>
        <DashboardLeftContainerContent />
      </DashboardLeftContainer>
    )
  } else {
    return (
      <DashboardLeftContainer>
        <DashboardLeftContainerContent />
      </DashboardLeftContainer>
    )
  }
}

export default withRouter(withAuth(MyFreebirdDashboardLeft))
